import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_createSalesOrderH = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/create`, data);
};

export const billing_expense_getSalesOrder = () => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/get`);
};

export const billing_expense_getSalesOrderBycompany = (query) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/getbycompany`, query);
};

export const billing_expense_getSalesOrderBySubmit = (company_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/getStatusSubmit/${company_id}`);
};

export const billing_expense_getAllSOById = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/getAllById/${id}`);
};

export const billing_expense_getCusId = (id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/getCusId/${id}`);
};

export const billing_expense_UpdateSO_H = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/${id}`, data);
};

export const billing_expense_deleteSOById = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.SALES_ORDER_H}` + `/${id}`);
};